import { Module, getModule, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import CommonModule from '@questelservices/common';
import store from '@/store'
import { Roles } from '@/common/Roles';

const commonModule = getModule(CommonModule, store);
@Module({ namespaced: true, dynamic: true, store, name: 'AuthorizationModule' })
export default class AuthorizationModule extends VuexModule {

  private tokenIsExpiring: boolean = false;
  private promptCancelImpersonation: boolean = false;
  private redirectionPathAfterCancel: string = null;
  // -------------------------------------------------------------------------------------------------------------------

  @Mutation
  public SET_PROMPT_CANCEL_IMPERSONATION(cancelImpersonationRequest: any): void {
    this.promptCancelImpersonation = cancelImpersonationRequest.promptCancel;
    this.redirectionPathAfterCancel = cancelImpersonationRequest.redirectionPath;
  }

  @Action({ commit: 'SET_PROMPT_CANCEL_IMPERSONATION', rawError: true})
  public setPromptCancelImpersonation(cancelImpersonationRequest: any): any {
    return cancelImpersonationRequest;
  }

  public get showCancelImpersonationDialog(): boolean {
    return this.promptCancelImpersonation;
  }

  public get getCancelImpersonationRedirectionPath(): string {
    return this.redirectionPathAfterCancel;
  }

  // -------------------------------------------------------------------------------------------------------------------
  @Mutation
  public SET_TOKEN_EXPIRING(expiring: boolean): void {
    this.tokenIsExpiring = expiring;
  }

  @Action({ commit: 'SET_TOKEN_EXPIRING', rawError: true})
  public setTokenExpiring(expiring: boolean): boolean {
    return expiring;
  }

  public get getTokenIsExpiring(): boolean {
    return this.tokenIsExpiring;
  }

  // -------------------------------------------------------------------------------------------------------------------

  public get userRoles(): Array<string> {
    return commonModule.authenticatedUser.roles || [];
  }

  public get userHasRole(): (role: string) => boolean {
    return (role) => commonModule.isAuthenticated && this.userRoles.some(r => r === role || r === Roles.Admin);
  }

  public get userHasAnyRole(): (roles: Array<string>) => boolean {
    return (roles) => {
      roles.push(Roles.Admin);
      return commonModule.isAuthenticated && this.userRoles.some(userRole => roles.includes(userRole));
    }
  }
}
